import React from 'react';
import { FormGroup, Label, Input } from 'reactstrap';

const FormInputSwitch = ({ control, groupClassName, handleChange, inputRef, size='md', className='p-1', hideCaption=false }) => {
  const { caption, name, value, descriptionStatus, id } = control;

  const applyColor = (inputState) => {
    if (inputState === 'is_locked') return `${value ? 'text-danger' : 'text-secondary'}  mr-3`;
    return `${value ? 'text-primary' : 'text-secondary'}  mr-3`;
  };

  const outerContainerClassName = `ml-2 d-flex w-100 form-switch ${className}`;

  return (
    <div className={`mt-0 mb-0 row ${groupClassName}`}>
      {caption && !hideCaption && (
        <Label for={name} sm={12} className="fw-bold">
          {caption}
        </Label>
      )}
      <div className={ outerContainerClassName }>
        <Input
          type="checkbox"
          role="switch"
          id={id ?? name}
          name={name}
          checked={value}
          onChange={handleChange}
          className="ml-3 mr-2 form-check-input"
          innerRef={inputRef || null}
          bsSize={size}
        />

        <div className={applyColor(name)}>
          {value ? descriptionStatus?.switchOn : descriptionStatus?.switchOff}
        </div>
      </div>
      {control.description && (<small className="ml-3 mt-1 text-success">{control.description}</small>)}
    </div>
  );
};

export default FormInputSwitch;
